import { dayMonthTime } from '../../../day.js';
import type { Sources } from './api.js';
export type Source = Sources['people'][number]['sources'][number];
export const firstName = (name: string) => name.trim().split(/\s+/)[0] ?? name;
export const dateWords = (iso: string) => dayMonthTime(new Date(iso));
export function sourceName(kind: string): string | null {
  return ({
    m365_mail: 'Mail', m365_teams: 'Teams', m365_calendar: 'Calendar',
    mail: 'Mail', teams: 'Teams', meetings: 'Teams', calendar: 'Calendar',
    granola: 'Granola', motion: 'Motion',
  } as Record<string, string>)[kind] ?? null;
}
export const problem = (s: Source) => ['quiet', 'refused', 'failed'].includes(s.state);
export function stateWords(s: { state: string } & Partial<Pick<Source, 'since' | 'message' | 'paused'>>): string {
  switch (s.state) {
    case 'delivering': return 'Delivering';
    case 'quiet': return s.since ? `Quiet ${Math.max(0, Math.floor((Date.now() - Date.parse(s.since)) / 86400000))} days` : 'Quiet';
    case 'refused': return 'Transcripts refused';
    case 'failed': return s.message ? `Failed: ${s.message}` : 'Failed';
    case 'not_connected': return 'Not connected';
    case 'paused': return s.paused ? `Paused by ${s.paused.by.displayName} on ${dateWords(s.paused.at)}` : 'Paused';
    default: return '';
  }
}
export const changeWords = (name: string, source: string, resume: boolean) => resume
  ? `Cobrain reads ${firstName(name)}'s ${source} again from now. What arrived while it was paused is not read.`
  : `Cobrain stops reading ${firstName(name)}'s ${source} from now. Nothing already read is deleted.`;
